<div class="_form-client-component" [ngClass]="{'_page': edit}">

	<p class="_title" [translate]="'CLIENT.TITLE'" *ngIf="!isBeegoAppointment; else beegoTitle"></p>
	<ng-template #beegoTitle>
		<p class="_title" [translate]="'BEEGO_APPOINTMENT.CLIENT_TITLE'"></p>
	</ng-template>

	<ng-container *ngIf="formGroup">
		<ng-container *ngIf="!clientLocked; else clientLockedTemplate">
				
			<div class="_data-container">
				<!-- EDIT -->
				<ng-container *ngIf="edit">
					<div class="_data _half">
						<form-input label="{{ 'CLIENT.FIRSTNAME' | translate }}" [formControl]="formGroup.get('firstname') | cast"></form-input>
					</div>
					<div class="_data _half">
						<form-input label="{{ 'CLIENT.LASTNAME' | translate }}" [formControl]="formGroup.get('lastname') | cast"></form-input>
					</div>
				</ng-container>

				<!-- CREATE -->

					<div class="_search-container" *ngIf="!edit">

						<!-- FIRSTNAME (SEARCH) -->
						<div class="_data">
							<div class="_input-container">
								<ion-icon class="_search-icon" src="./assets/icons/search-outline.svg"></ion-icon>
								<input 
									[ngClass]="{'_has-results': searchResults.length > 0}" 
									(input)="autocomplete({firstname: $any($event).target.value})" 
									type="text" 
									autocomplete="no-auto" 
									[formControl]="formGroup.get('firstname') | cast" 
									placeholder="{{'CLIENT.FIRSTNAME_PLACEHOLDER' | translate}}"
								>
								<div class="_status">
									<ng-container *ngIf="loading; else result">
										<ion-spinner name="dots"></ion-spinner>
									</ng-container>
									<ng-template #result>
										<ion-icon *ngIf="error && formGroup.get('firstname').value" class="_invalid" src="./assets/icons/invalid-input.svg"></ion-icon>
									</ng-template>
								</div>
							</div>
							<form-validation-error [control]="formGroup.get('firstname') | cast"></form-validation-error>
						</div>

						<!-- LASTNAME (SEARCH) -->
						<div class="_data">
							<div class="_input-container">
								<ion-icon class="_search-icon" src="./assets/icons/search-outline.svg"></ion-icon>
								<input 
									[ngClass]="{'_has-results': searchResults.length > 0}" 
									(input)="autocomplete({lastname: $any($event).target.value})" 
									type="text" autocomplete="no-auto" 
									[formControl]="formGroup.get('lastname') | cast" 
									placeholder="{{'CLIENT.LASTNAME_PLACEHOLDER' | translate}}"
								>
								<div class="_status">
									<ng-container *ngIf="loading; else result">
										<ion-spinner name="dots"></ion-spinner>
									</ng-container>
									<ng-template #result>
										<ion-icon *ngIf="error && formGroup.get('lastname').value" class="_invalid" src="./assets/icons/invalid-input.svg"></ion-icon>
									</ng-template>
								</div>
							</div>
							<form-validation-error [control]="formGroup.get('lastname') | cast"></form-validation-error>
						</div>

						<!-- BIRTHDATE (SEARCH) -->
						<div class="_data">
							<div class="_input-container _date-container" [ngClass]="{'_has-results': searchResults.length > 0}">
								<ion-icon class="_search-icon" src="./assets/icons/search-outline.svg"></ion-icon>
								
								<form-date 
									[formControl]="formGroup.get('birthDate') | cast" placeholder="{{'CLIENT.EXTRA.BIRTH_DATE' | translate}}" [ngClass]="{'_is-loading': loading, '_has-error': error && formGroup.get('birthDate').value}"
								></form-date>

								<div class="_status">
									<ng-container *ngIf="loading; else result">
										<ion-spinner name="dots"></ion-spinner>
									</ng-container>
									<ng-template #result>
										<ion-icon *ngIf="error && formGroup.get('birthDate').value" class="_invalid" src="./assets/icons/invalid-input.svg"></ion-icon>
									</ng-template>
								</div>
							</div>
							<form-validation-error [control]="formGroup.get('birthDate') | cast"></form-validation-error>
						</div>

						<!-- SEARCH RESULTS -->
						<div class="_search-results" *ngIf="searchResults.length > 0">
							<div class="_search-result" *ngFor="let client of searchResults" (click)="selectClient(client)">
								<p class="_name">{{client.firstname}} {{client.lastname}}</p>
								<p class="_address" *ngIf="client.Address">{{client.Address | address}}</p>
								<p class="_address" *ngIf="client.gender || client.birthDate">
									<ng-container *ngIf="client.birthDate">{{client.birthDate | date:"dd/MM/yyyy"}}</ng-container>
									<ng-container *ngIf="client.birthDate && client.gender"> - </ng-container>
									<ng-container *ngIf="client.gender">{{client.gender}}</ng-container>
								</p>
							</div>
						</div>
						
					</div>
			</div>

			<p class="_small-title _small-sub-title" [translate]="'CLIENT.ADDRESS'"></p>

			<div class="_data-container">
				<form-full-address style="width: 100%;" [formGroup]="formGroup.get('Address') | cast" [blockZipcode]="isBeegoAppointment"></form-full-address>
			</div>

			<p class="_small-title _small-sub-title" [translate]="'CLIENT.CONTACT.TITLE'"></p>

			<div class="_data-container">
				<div class="_data _full">
					<form-input label="{{ 'CLIENT.CONTACT.EMAIL' | translate }}" [formControl]="formGroup.get('email') | cast"></form-input>
				</div>

				<div class="_data _full _gdpr-container" (click)="gdprClick($event)">
					<ng-container *ngIf="formGroup.get('email').valid && formGroup.get('email').value; else emailempty">
						<ion-checkbox color="success" [formControl]="formGroup.get('gdpr') | cast" ></ion-checkbox>
						<ion-label [translate]="'CLIENT.EXTRA.GDPR'" [translateParams]="{client: formGroup.get('firstname').value ?? 'De bezoeker'}"></ion-label>
					</ng-container>
					<ng-template #emailempty>
						<ion-checkbox color="success" [formControl]="formGroup.get('gdpr') | cast" [disabled]="true"></ion-checkbox>
						<div>
							<p [translate]="'CLIENT.EXTRA.GDPR_NO_EMAIL'" *ngIf="gdpr_email_missing"></p>
							<ion-label [translate]="'CLIENT.EXTRA.GDPR'" [translateParams]="{client: formGroup.get('firstname').value ?? 'De bezoeker'}"></ion-label>
						</div>
					</ng-template>
				</div>
			
				<div class="_data _half">
					<form-input label="{{ 'CLIENT.CONTACT.PHONE' | translate }}" [formControl]="formGroup.get('telephone') | cast"></form-input>
				</div>
				<div class="_data _half">
					<form-input label="{{ 'CLIENT.CONTACT.LANDLINE' | translate }}" [formControl]="formGroup.get('landline') | cast"></form-input>
				</div>		
			</div>

			<p class="_small-title _small-sub-title" [translate]="'CLIENT.EXTRA.TITLE'"></p>
			<div class="_data-container">
				<div class="_data _full">	
					<form-select label="{{ 'CLIENT.AGE_CATEGORY.TITLE' | translate }}" [formControl]="formGroup.get('ageCategory') | cast" [items]="ageCategories" bindValue="value" bindLabel="{{'label' | translate }}" [multiple]="false">
					</form-select>	
				</div>
				<div class="_data _full" *ngIf="edit">
					<form-date label="{{ 'CLIENT.EXTRA.BIRTH_DATE' | translate }}" [formControl]="formGroup.get('birthDate') | cast"></form-date>
				</div>
				<div class="_data _full" *ifUserHasPermissions="[UserPermissions.ReadClientsSocial]">
					<form-input label="{{ 'CLIENT.EXTRA.SOCIAL' | translate }}" [formControl]="formGroup.get('social') | cast"></form-input>
				</div>
				<div class="_data _full">	
					<form-select label="{{ 'CLIENT.GENDER.TITLE' | translate }}" [formControl]="formGroup.get('gender') | cast" [items]="genders" bindValue="value" bindLabel="{{'label' | translate }}" [multiple]="false">
					</form-select>	
				</div>
				<div class="_data _full">
					<form-select label="{{ 'CLIENT.EXTRA.ORIGIN' | translate }}" [formControl]="formGroup.get('ClientOriginId') | cast" [items]="clientOrigins" bindValue="id" bindLabel="name" [multiple]="false">
					</form-select>
				</div>
				<div class="_data _full">
					<form-select label="{{ 'CLIENT.DIGIBANK_TARGET_AUDIENCE.TITLE' | translate }}" [formControl]="formGroup.get('digibankTargetAudience') | cast" [items]="digibankTargetAudiences" bindValue="name" bindLabel="name" [multiple]="true">
					</form-select>
				</div>
				<div class="_data _full">
					<form-select *ngIf="!isBeegoAppointment; else beegoDevices" label="{{ 'CLIENT.EXTRA.DEVICES' | translate }}" [formControl]="formGroup.get('devices') | cast" [items]="deviceTypes" bindValue="name" bindLabel="name" [multiple]="true">
					</form-select>
					<ng-template #beegoDevices>
						<form-select label="{{ 'BEEGO_APPOINTMENT.DEVICES' | translate }}" [formControl]="formGroup.get('devices') | cast" [items]="deviceTypes" bindValue="name" bindLabel="name" [multiple]="true">
						</form-select>
					</ng-template>
				</div>
				<div class="_data _full">
					<form-textarea label="{{ 'CLIENT.EXTRA.NOTE' | translate }}" [formControl]="formGroup.get('note') | cast"></form-textarea>
				</div>

				<div class="_data-container _digicheque-count" *ngIf="edit">
					<client-digicheques-count-component [clientId]="formGroup.get('id').value"></client-digicheques-count-component>
				</div>
			</div>
		</ng-container>

		<ng-template #clientLockedTemplate>
			<div class="_info">
				<client-details-component [client]="formGroup.value" [clientNavigationEnabled]="false"></client-details-component>

				<div *ngIf="errorMessages.length > 0" class="_error_messages">
					<b *ngIf="template === 'desktop'" >{{'CLIENT.ERROR_MESSAGES.TITLE' | translate}}</b>
					<b *ngIf="template === 'mobile'" >{{'CLIENT.ERROR_MESSAGES.TITLE_MOBILE' | translate}}</b>
					<span *ngFor="let error of errorMessages">
						{{'CLIENT.ERROR_MESSAGES.' + error.label | uppercase | translate}}: {{error.message}}
					</span>
				</div>

				<button *ngIf="template === 'desktop'" (click)="openClient(formGroup.value)" class="_button _neutral-button">
					<span [translate]="'CLIENT.EXTRA.UPDATE'" [translateParams]="{client: formGroup.get('firstname').value ?? 'De bezoeker'}"></span>
				</button>
			</div>
		</ng-template>
	</ng-container>			
</div>